import { COLORS } from "shared/consts";
import { toEm, toRem } from "shared/helpers";
import styled, {createGlobalStyle, css} from "styled-components";

export const TableWrapper = styled.div`
    margin: 0 ${toRem(-16)};
    @media (width < ${toEm(992)}) {
        padding-bottom: ${toRem(56)};
    }
    max-height: 100%;

    .rdt_TableRow.row--archived .rdt_TableCell:not([data-column-id="settings-cell"]) {
        opacity: .35;
    }
`;

export const TableEditHeaderPopoverWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${toRem(4)};
`;

type ItemProps = { $isActive: boolean };
export const TableEditHeaderPopoverItem = styled.div<ItemProps>`
    display: flex;
    align-items: center;
    gap: ${toRem(8)};
    padding: ${toRem(8)} ${toRem(12)};
    font-size: ${toRem(14)};
    line-height: ${20 / 14};
    cursor: pointer;
    border-radius: ${toRem(8)};
    color: ${(p) => (p.$isActive ? COLORS.ACCENT.DEFAULT : COLORS.FG.DISABLED)};
    ${(p) =>
            p.$isActive &&
            css`
                background-color: ${COLORS.ACCENT.CONTAINER_SOFT};
            `}
`;

export const TableMobileWrapper = styled.div`
    background: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
    padding: 8px 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const TableMobileItem = styled.div`
    display: grid;
    background: ${COLORS.BG.SURFACE1};
    padding: 16px;
    position: relative;
    border-radius: 16px;
    grid-template-columns: ${toRem(36)} auto;
    gap: 0 ${toRem(12)};
    cursor: pointer;
    transition: all 0.3s ease 0s;

    @media (any-hover: hover) {
        &:hover {
            background-color: ${COLORS.BG.SURFACE3};
        }
    }

    i {
        grid-row: 1 / span 2;
        width: ${toRem(36)};
        height: ${toRem(36)};
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: ${toRem(8)};
        background-color: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
    }

    div {
        font-size: ${toRem(14)};
        font-weight: 500;
        line-height: ${16 / 14};
    }

    span {
        color: ${COLORS.FG.MUTED};
        font-size: ${toRem(12)};
        line-height: ${16 / 12};
    }
`;

export const TableMobileIcon = styled.div`
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    width: 24px;
    height: 24px;
    
    svg {
        width: 100%;
        height: 100%;
    }
`

export const HivesFiltersDrawerWrapper = styled.div`
    background-color: ${COLORS.BG.PAGE_FILLED};
    height: 100%;
    display: flex;
    flex-direction: column;
    @media (width >= ${toRem(400)}) {
        width: ${toRem(400)};
    }
    @media (width < ${toRem(400)}) {
        width: 100vw;
    }
`;

export const HivesFiltersBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${toRem(8)};
    padding: ${toRem(16)};
    flex: 1 1 auto;
    max-height: 100%;
    overflow: hidden auto;
`;

export const HivesFiltersFooter = styled.div`
    padding: ${toRem(16)};
`;

export const TableSettingsCol = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    &:hover {
        svg {
            background: #eaeaec;
            border-radius: 8px;
        }
    }
    
`;

export const HiveMarkCellContainer = styled.div`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
`

export const HiveStatesWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
`;

export const HiveStateItem = styled.div`
    padding: 2px 6px;
    color: var(--tagitem-primary-label-color-default, rgba(16, 24, 40, 1));
    font-size: 12px;
    font-weight: 400;
    border-radius: 4px;
    background: var(--tagitem-primary-bg-color-default, rgba(88, 93, 105, 0.1));
`;


export const HiveHapinessContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const HiveHapinessValue = styled.span`
    color: var(--fg-default, rgba(16, 24, 40, 1));
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
`;

export const HiveHapinessIconWrapper = styled.div`
    width: 20px;
    height: 20px;
    
    svg {
        width: 100%;
        height: 100%;
    }
`;



export const HiveDeviceContainer = styled.div`
    display: flex;
    gap: 6px;
    align-items: center;
`;

export const HiveDeviceIconWrapper = styled.div`

`;

export const HiveDeviceValue = styled.span`
    color: var(--fg-default, rgba(16, 24, 40, 1));
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
`;

export const HiveDeviceNone = styled.span`
`;


export const HiveActionsPopup = styled.div`
    //position: absolute;
    //top: calc(100% - 10px);
    //right: 0;
    width: max-content;
    height: max-content;
    padding: 8px;
    background: ${COLORS.BG.SURFACE1};
    border-bottom: 1px solid var(--border-muted, rgba(88, 93, 105, 0.15));
    z-index: 10;
    gap: 4px;
    display: flex;
    opacity: 1;
    flex-direction: column;
`

export const HiveActionsPopupElement = styled.div`
    padding: 6px 12px;   
    background: ${COLORS.BG.SURFACE1};
    transition: background .3s ease-in-out;
    border-radius: 8px;

    color: var(--dropdownmenu-primary-itemvalue-color-default, rgba(16, 24, 40, 1));
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    
    
    &:hover {
        background: #eaeaec;
    }
`

export const GlobalSettings = createGlobalStyle`
    .settingsPopupTable {
        inset: -16px 0px auto auto!important;
    }
`;